<template>
  <footer class="foots">
    <!-- <div class="subscribe-box">
      <div class="subscribe-box-div">
        <span class="fff fnt_30">{{ globalDataArray.siteTemplateLanguage.subscription_user_title }}</span>
        <span class="fs fnt_16">{{ globalDataArray.siteTemplateLanguage.subscription_user_content }}</span>
        <div style="margin-top:10px;">
          <a-form-model layout="inline" ref="ruleForm" :model="ruleForm" @submit="submitForm" @submit.native.prevent :rules="rules">
            <a-form-model-item prop="name" style="margin: 10px 10px;">
              <a-input size="large" v-model="ruleForm.name" :placeholder="globalDataArray.siteTemplateLanguage.name_text" class="f-in" />
            </a-form-model-item>
            <a-form-model-item prop="email" style="margin: 10px 10px;">
              <a-input size="large" v-model="ruleForm.email" :placeholder="globalDataArray.siteTemplateLanguage.site_email" class="f-in" />
            </a-form-model-item>
            <a-form-model-item style="margin: 10px 10px;">
              <a-button type="primary" html-type="submit" style="width: 200px; height: 55px; line-height: 55px; font-size: 18px;">{{ globalDataArray.siteTemplateLanguage.subscription_user_btn }}</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div> -->
    <div class="w1440">
      <div class="top">
        <div>
          <span class="fff fnt_20 textpadding">{{ globalDataArray.siteTemplateLanguage.subscription_user_title }}</span>
          <div class="subscribe-form" style="margin-top:30px;">
            <a-form-model layout="inline" ref="ruleForm" :model="ruleForm" @submit="submitForm" @submit.native.prevent :rules="rules">
              <a-form-model-item prop="name" style="margin: 10px 10px;">
                <a-input size="large" v-model="ruleForm.name" :placeholder="globalDataArray.siteTemplateLanguage.name_text" class="f-in-tt" @blur="handleNameBlur" />
              </a-form-model-item>
              <a-form-model-item prop="email" style="margin: 10px 10px;">
                <a-input size="large" v-model="ruleForm.email" :placeholder="globalDataArray.siteTemplateLanguage.site_email" class="f-in-tt" @blur="handleEmailBlur" />
              </a-form-model-item>
              <a-form-model-item style="margin: 10px 10px;">
                <a-button type="primary" html-type="submit" style="height: 40px; line-height: 40px; font-size: 18px;">{{ globalDataArray.siteTemplateLanguage.subscription_user_btn }}</a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>
        <div class="contact">
          <!-- <div class="otherLink fr" v-if="article.length>0"> -->
          <div class="otherLink fnt_16" v-if="article.length>0">
            <template v-for="(item,index) in article">
              <div class="item" :key="index">
                <router-link v-if="item.linkUrl!=''&&item.linkUrl!=null" :to="item.linkUrl">{{ item.title }}</router-link>
                <!--              <router-link v-else-if="fromQuery!=''&&fromQuery!=null" target="_blank" :to="'/article/'+item.parentId+'?from='+fromQuery">{{ item.title }}</router-link>-->
                <!--<router-link v-else target="_blank" :to="'/article/'+item.parentId">{{ item.title }}</router-link>-->
                <router-link v-else-if="fromQuery!=''&&fromQuery!=null" target="_blank" :to="'/document?id='+item.parentId+'&from='+fromQuery">{{ item.title }}</router-link>
                <router-link v-else target="_blank" :to="'/document?id='+item.parentId">{{ item.title }}</router-link>
              </div>
            <!-- <br :key="`br-${index}`"> -->
            </template>
          </div>
          <!-- <div class="f1 " :class="curLang == 'zh_CN' ? 'fnt_30' : 'fnt_20'">{{ globalDataArray.siteTemplateLanguage.bot_msg_thanks }}</div>
          <div class="f2 fnt_16 mt_30">
            {{ globalDataArray.siteTemplateLanguage.site_contact }} : <a :href="'tel:'+globalDataArray.siteInfo.contact">{{ globalDataArray.siteInfo.contact }}</a><br>
            {{ globalDataArray.siteTemplateLanguage.site_email }} : <a :href="'mailto:'+globalDataArray.siteInfo.email">{{ globalDataArray.siteInfo.email }}</a>
          </div> -->
        </div>

        <div class="otherMail fnt_16">
          {{ globalDataArray.siteTemplateLanguage.bot_btn_zijin }} : <a :href="'mailto:'+globalDataArray.siteInfo.fundText">{{ globalDataArray.siteInfo.fundText }}</a><br>
          {{ globalDataArray.siteTemplateLanguage.bot_btn_project }} : <a :href="'mailto:'+globalDataArray.siteInfo.projectText">{{ globalDataArray.siteInfo.projectText }}</a><br>
          {{ globalDataArray.siteTemplateLanguage.bot_btn_law }} : <a :href="'mailto:'+globalDataArray.siteInfo.lawText">{{ globalDataArray.siteInfo.lawText }}</a><br>
          {{ globalDataArray.siteTemplateLanguage.bot_btn_media }} : <a :href="'mailto:'+globalDataArray.siteInfo.mediumText">{{ globalDataArray.siteInfo.mediumText }}</a><br>
          {{ globalDataArray.siteTemplateLanguage.bot_btn_jiandu }} : <span>{{ globalDataArray.siteTemplateLanguage.bot_btn_jiandu_text }}</span><br>
          {{ globalDataArray.siteTemplateLanguage.bot_btn_mail }} : <a :href="'mailto:'+globalDataArray.siteTemplateLanguage.bot_btn_mail_text">{{ globalDataArray.siteTemplateLanguage.bot_btn_mail_text }}</a>
        </div>
      </div>

      <div class="logoAddress" style="border-bottom:1px solid #39434f; padding: 20px;">
        <!-- <div class="logo"><img :src="globalDataArray.siteInfo.logoFooter" alt=""></div> -->
        <div class="mt-68px" style="margin: 5px auto;">
          <ul class="socially-pic m-0 flex list-none p-0">
            <li
              class="use-qrcode w-40px! h-40px! chat i-icons:chat relative hover:i-icons:chat-hover"
            >
              <!--              <img-->
              <!--                class="lazyload absolute hidden"-->
              <!--                :src="require('@/assets/images/chat.jpg')"-->
              <!--                alt="chat"-->
              <!--              >-->
            </li>
            <li
              class="use-qrcode w-40px! h-40px! ml-16px wechat i-icons:wechat relative hover:i-icons:wechat-hover"
            >
              <!--              <img-->
              <!--                class="lazyload absolute hidden"-->
              <!--                :src="require('@/assets/images/wechat.jpg')"-->
              <!--                alt="wechat"-->
              <!--              >-->
            </li>
            <li
              class="use-qrcode h-40px! ml-16px"
            >
              <span style="height: 40px;line-height: 40px;" v-if="curLang == 'zh_CN'" class="address fnt_16 mt_30"><a :href="'http://api.map.baidu.com/geocoder?address='+globalDataArray.siteInfo.address+'&output=html&src=webapp.baidu.openAPIdemo'" target="_blank">{{ globalDataArray.siteInfo.address }}</a></span>
              <span style="height: 40px;line-height: 40px;" v-else class="address fnt_16 mt_30">{{ globalDataArray.siteInfo.address }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="bot cf" :class="curLang == 'zh_CN' ? '' : 'foreignDiv'">
        <div class="copyright ovh" v-html="globalDataArray.siteInfo.copyright">
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Cookies from 'js-cookie'
import { getArticleByLevel, addSubscription } from '@/api/api'
import { message } from 'ant-design-vue'
export default {
  name: 'Foots',
  data() {
    return {
      article: [],
      curLang: '',
      fromQuery: '',
      nameBlurTimer: null,
      emailBlurTimer: null,
      ruleForm: {
        name: undefined,
        email: undefined
      },
      rules: {
        name: [
          { required: true, message: this.globalDataArray.siteTemplateLanguage.subscription_user_name, trigger: 'blur' },
          { min: 1, max: 50, message: this.globalDataArray.siteTemplateLanguage.subscription_user_name_length, trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.globalDataArray.siteTemplateLanguage.subscription_user_email_null, trigger: 'blur' },
          { type: 'email', message: this.globalDataArray.siteTemplateLanguage.subscription_user_email, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
    // 监听路由变化，清空表单数据
    '$route'(to, from) {
      if (to.path !== from.path) {
        this.clearForm()
      }
    }
  },
  mounted() {
    this.init()
    const that = this
    const currentLanguge = Cookies.get('DEFAULT_LANG')
    if (currentLanguge != null && currentLanguge != undefined) {
      that.curLang = currentLanguge
    } else {
      that.curLang = that.globalDataArray.siteLanguage[0].value
    }

    if (this.$route.query.from) {
      this.fromQuery = this.$route.query.from
    }
  },
  beforeDestroy() {
    // 清理定时器
    if (this.nameBlurTimer) {
      clearTimeout(this.nameBlurTimer)
    }
    if (this.emailBlurTimer) {
      clearTimeout(this.emailBlurTimer)
    }
  },
  methods: {
    init() {
      const that = this
      // const params = 'type=1,2,3,4,8,9'
      // getArticle(params).then(res => {
      //   if (res.success) {
      //     // console.log(res)
      //     that.article = res.result
      //   }
      // })
      getArticleByLevel().then(res => {
        if (res.success) {
          // console.log(res)
          that.article = res.result
        }
      })
    },
    submitForm() {
      const that = this
      that.$refs['ruleForm'].validate(valid => {
        if (valid) {
          addSubscription(that.ruleForm).then(res => {
            if (res.success) {
              message.success('订阅成功！')
              that.ruleForm = {
                name: undefined,
                email: undefined
              }
            } else {
              message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    handleNameBlur() {
      // 清除之前的定时器
      if (this.nameBlurTimer) {
        clearTimeout(this.nameBlurTimer)
      }
      // 设置2秒后清空姓名字段的错误显示
      this.nameBlurTimer = setTimeout(() => {
        this.$refs.ruleForm.clearValidate(['name'])
      }, 2000)
    },
    handleEmailBlur() {
      // 清除之前的定时器
      if (this.emailBlurTimer) {
        clearTimeout(this.emailBlurTimer)
      }
      // 设置2秒后清空邮箱字段的错误显示
      this.emailBlurTimer = setTimeout(() => {
        this.$refs.ruleForm.clearValidate(['email'])
      }, 2000)
    },
    // 清空表单数据
    clearForm() {
      this.ruleForm = {
        name: undefined,
        email: undefined
      }
      // 清空表单验证错误
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate()
      }
    }
  }
}
</script>

<style lang="scss">
.socially-pic {

  .use-qrcode {
    &:hover {
      img {
        display: block;
      }
    }

    img {
      bottom: 50px;
      left: 50%;
      width: 130px;
      height: 130px;
      padding: 10px;
      object-fit: cover;
      background-color: #fff;
      border-radius: 4px;
      transform: translateX(-50%);
      max-width: unset;
      max-height: unset;
    }
  }
}
</style>
<style scoped>
/* 穿透 Scoped CSS，精确覆盖 */
::v-deep .has-error .ant-input {
  background: linear-gradient(180deg, rgba(255, 255, 255, .05), rgba(255, 255, 255, .2)) !important;
	color: #FFF !important;
	border-color: #ff4d4f !important; /* 使用 Ant Design 的错误色 */
}
.textpadding{
  padding: 0 14px;
}
</style>
